export default "__VITE_ASSET__Pq3WZWoH__"